import { useProfile } from "contexts/ProfileContext.tsx";
import Icon from "core/components/Icon.tsx";
import IconButton from "core/components/IconButton.tsx";
import Separator from "core/components/Separator";
import { motion } from "framer-motion";
import useOutsideClick from "hooks/useOutsideClick.ts";
import { useNavigate } from "react-router-dom";
import logoNavbarMobile from "../../../images/c1010.jpeg";
import iconeUsuario from "../../../images/iconeUsuario.png";
import { userItems } from "../Dropdowns/constants/Dropdown.constants.tsx";
import "../NavbarV3.css";
import { NavbarItemList } from "../NavbarV3.tsx";
import MobileTopBar from "./MobileTopBar.tsx";

interface MobileNavbarProps {
	title: string;
	handleLogoutClick: () => void;
}

function MobileNavbar({ title, handleLogoutClick }: MobileNavbarProps) {
	const { profile, coresEmpresa } = useProfile();
	const navigate = useNavigate();

	const [isOpenSidebar, toggleSidebar, closeSidebar, refSidebar] =
		useOutsideClick();

	return (
		<>
			<MobileTopBar onMenuClick={toggleSidebar} title={title} />

			{isOpenSidebar && (
				<div onClick={closeSidebar} className="mobile-overlay" />
			)}

			<motion.aside
				ref={refSidebar}
				initial={{ x: "-100%" }}
				animate={{ x: isOpenSidebar ? 0 : "-100%" }}
				transition={{ type: "tween", duration: 0.25 }}
				className="mobile-aside"
				style={{ background: coresEmpresa.headerFooter }}
			>
				<div>
					<div onClick={toggleSidebar} className="navbar-title-mobile">
						<div className="aside-placeholder" />
						<img
							onClick={() => {
								navigate("/");
							}}
							style={{ cursor: "pointer" }}
							src={logoNavbarMobile}
							alt="logoNavbar"
							className="icone-mobile"
						/>
						<IconButton
							icon="X"
							size="lg"
							borderColor="#ccc"
							onClick={() => {}}
							backgroundColor="rgba(0, 0, 0, 0)"
							theme="light"
						/>
					</div>
					<Separator size="sm" />
					<p className="title-menu-mobile">Início</p>
					<Separator size="sm" />
				</div>
				<div className="navbar-items-content-mobile">
					<NavbarItemList />
					<div className="user-section-mobile">
						<div className="user-item-mobile">
							{userItems.map((item) => (
								<p
									onClick={() => navigate(item.rota)}
									key={item.label}
									className="items-user-mobile"
								>
									{item.label}
								</p>
							))}
							<p className="items-user-mobile" onClick={handleLogoutClick}>
								Sair
							</p>
						</div>
						<div className="image-perfil-mobile">
							{profile?.profileImage && (
								<img
									src={
										profile?.profileImage && profile?.profileImage.tipo
											? `data:${profile?.profileImage.tipo};base64,${profile?.profileImage.dado}`
											: iconeUsuario
									}
									alt="Uploaded preview"
								/>
							)}
							{!profile?.profileImage && (
								<Icon name="User" size="xl" theme="light" />
							)}
						</div>
					</div>
				</div>
			</motion.aside>
		</>
	);
}

export default MobileNavbar;
